var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.schoolId)?_c('v-chip',{attrs:{"small":"","outlined":"","to":_vm.collegeRoute,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }